<div (click)="showCreateGroup.emit()" class="item create-group-button">
  <div class="item__content">
    <mat-icon>add</mat-icon>
    <span class="item__label">{{'Create a new group'}}</span>
  </div>
</div>
